<template>
  <div :class="{'over-auto':showWay==='table'}">
    <yxt-radio-group
      v-if="!hideViewWayTabs"
      v-model="showWay"
      class="gwnl-web-radio-group2"
      @change="changed"
    >
      <yxt-radio-button label="radar">
        {{ $t('pc_gwnl_web_radar') }}
      </yxt-radio-button>
      <yxt-radio-button label="table">
        {{ $t('pc_gwnl_web_table') }}
      </yxt-radio-button>
    </yxt-radio-group>
    <yxtf-tooltip
      v-if="scene === 2 && !hideViewWayTabs"
      :content="$t('pc_gwnl_web_training_tip'/**多次测评进行比较，得分将统一转化为10分制 */)"
      placement="top"
    >
      <yxtf-svg
        style="position: absolute; top: 6px;"
        :remote-url="gwnlMediaDomain + 'media/images/pc_svg/common'"
        class="color-gray-6 hover-primary-6 ml6"
        width="20px"
        height="20px"
        icon-class="tooltip"
      />
    </yxtf-tooltip>
    <div class="mt32">
      <skills-radar
        v-if="showWay==='radar'"
        :close-animate="closeAnimate"
        :fields="fields"
        :hideSkillLevelBeforeEval="hideSkillLevelBeforeEval"
        :skillWithLevel="skillWithLevel"
        :skillsList="detail.jqSkillClassifications || []"
      />
      <skills-table
        v-if="showWay==='table'"
        :fields="fields"
        :skillWithLevel="skillWithLevel"
        :skillsList="detail.jqSkillClassifications || []"
      />
    </div>
  </div>
</template>

<script>
import skillsTable from './detailSkillsTable';
import skillsRadar from './detailSkillsRadar';
import { GWNL_MEDIA_DOMAIN } from 'yxt-biz-pc/packages/ability-preview/src/components/domain.js';

export default {
  components: {
    skillsTable,
    skillsRadar
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    hideViewWayTabs: Boolean,
    closeAnimate: Boolean,
    scene: {
      type: Number,
      default: 1 // 1 岗位地图 2 测训一体
    },
    fields: {
      type: Array,
      default: () => []
    },
    hideSkillLevelBeforeEval: Boolean,
    skillWithLevel: Boolean
  },
  data() {
    return {
      showWay: 'radar',
      gwnlMediaDomain: GWNL_MEDIA_DOMAIN
    };
  },
  methods: {
    changed(v) {
      this.$emit('viewerSwitched', v === 'radar');
    }
  }
};
</script>
